export const guestLang = {
    statistic: {
        'en': 'REFERRAL STATISTIC',
        'fr': 'STATISTIQUE DE PARRAINAGE',
        'de': 'EMPFEHLUNGSSTATISTIK',
        'ko': '추천 통계',
        'ch': '推荐统计',
        'ru': 'РЕФЕРАЛЬНАЯ СТАТИСТИКА',
        'it': 'STATISTICHE DI RIFERIMENTO',
        'jap': '紹介データの統計',
        'port': 'ESTATÍSTICA DE REFERÊNCIA',
        'turk': 'TAVSİYE İSTATİSTİKLERİ',
        'viet': 'THỐNG KÊ GIỚI THIỆU',
        'spa': 'ESTADÍSITICAS DE REFERIDOS',
        'arab': 'إحصائيات الإحالة'
    },
    guest: {
        'en': 'MY GUESTS',
        'fr': 'MES INVITÉS',
        'de': 'MEINE GÄSTE',
        'ko': '내 게스트',
        'ch': '我的访客',
        'ru': 'МОИ ГОСТИ',
        'it': 'I MIEI OSPITI',
        'jap': 'Myゲスト',
        'port': 'MEUS CONVIDADOS',
        'turk': 'KONUKLARIM',
        'viet': 'KHÁCH CỦA TÔI',
        'spa': 'MIS INVITADOS',
        'arab': 'ضيوفي'
    },
    title: {
        'en': 'My Guest group',
        'fr': 'Mon groupe dinvités',
        'de': 'Meine Gästegruppe',
        'ko': '내 게스트 그룹',
        'ch': '我的嘉宾组',
        'ru': 'Моя гостевая группа',
        'it': 'Il mio gruppo di ospiti',
        'jap': '私のゲストグループ',
        'port': 'Meu grupo convidado',
        'turk': 'Misafir grubum',
        'viet': 'Nhóm Khách của tôi',
        'spa': 'Mi grupo de invitados',
        'arab': 'مجموعة ضيوفي'
    },
    date: {
        'en': 'DATE REGISTRATION',
        'fr': 'DATE DINSCRIPTION',
        'de': 'DATUM DER REGISTRIERUNG',
        'ko': '등록일',
        'ch': '注册日期',
        'ru': 'ДАТА РЕГИСТРАЦИИ',
        'it': 'DATA DI REGISTRAZIONE',
        'jap': '日付登録',
        'port': 'REGISTRO DE DATA',
        'turk': 'TARİH TESCİLİ',
        'viet': 'NGÀY ĐĂNG KÝ',
        'spa': 'FECHA DE REGISTRO',
        'arab': 'تاريخ التسجيل'
    },
    status: {
        'en': 'Status',
        'fr': 'Statut',
        'de': 'Status',
        'ko': '상태',
        'ch': '状态',
        'ru': 'Статус',
        'it': 'Stato',
        'jap': 'ステータス',
        'port': 'Status',
        'turk': 'Durum',
        'viet': 'Trạng thái',
        'spa': 'Estado',
        'arab': 'حالة'
    },
    name: {
        'en': 'Name',
        'fr': 'Prénom',
        'de': 'Name',
        'ko': '이름',
        'ch': '名字',
        'ru': 'Имя',
        'it': 'Nome',
        'jap': '名',
        'port': 'Nome',
        'turk': 'İsim',
        'viet': 'Tên',
        'spa': 'Nombre',
        'arab': 'اسم'
    },
    surname: {
        'en': 'Surname',
        'fr': 'Nom',
        'de': 'Nachname',
        'ko': '성',
        'ch': '姓氏',
        'ru': 'Фамилия',
        'it': 'Cognome',
        'jap': '姓',
        'port': 'Sobrenome',
        'turk': 'Soyisim',
        'viet': 'Họ',
        'spa': 'Apellidos',
        'arab': 'لقب'
    },
}